import React, { useState, useRef, useLayoutEffect } from "react";
import CostoLavoroApp from './costo_lavoro/App.svelte';
import PopoverComponentCustom from "../components/popover_component";
import Footer from "../components/footer";


export default function CostoLavoro() {
  const svelteRef = useRef();
  useLayoutEffect(() => {
    while (svelteRef.current?.firstChild) {
      svelteRef.current?.firstChild?.remove();
    }
    new CostoLavoroApp({
      target: svelteRef.current,
    });
  }, []);

  return (
    <div className="min-h-full">
      <PopoverComponentCustom title="Calcolo Costo del Lavoro" />
      <main className="mt-2 pb-8">
        <div className="flex justify-center my-4 sm:mr-6">
          <div className="container-fluid w-full px-4 pt-2">
            <div ref={svelteRef}></div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

